import styled from 'styled-components';
import { Edit } from 'react-feather';
import { useDispatch } from 'react-redux';

import { setShow as setModalShow } from '~features/modals/ducks';
import { toggleDrawer } from '../ducks';

const PhoneNumber = ({ user }) => {
  const dispatch = useDispatch();
  const { phone } = user;

  return (
    <Container>
      <Number $defined={!!phone}>{phone || '(puh.numero puuttuu)'}</Number>
      <EditButton
        type="button"
        onClick={() => {
          dispatch(setModalShow('CHANGE_PHONE_NUMBER'));
          dispatch(toggleDrawer('profile'));
        }}
      >
        <Edit />
      </EditButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 18px;

  color: white;
`;

const Number = styled.div`
  color: ${({ $defined }) => ($defined ? 'white' : '#97ABCE')};
`;

const EditButton = styled.button`
  color: white;
`;

export default PhoneNumber;
